import React from "react";
import ReactTable from "@dhn/components/molecules/data-table";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import useActions from "./useActions";
import ModalHeader from "@dhn/components/molecules/modal-header";
import DetailList from "@dhn/components/molecules/detail-list";

export default function ModalAllergyDetail({ isOpen, toggle, selectedItem }) {
  const [{ state }, actions] = useActions({ isOpen, toggle, selectedItem });

  const { loadingMolecules } = actions;

  const { data } = state;

  return (
    <Modal isOpen={isOpen} toggle={() => toggle()} size="lg" centered>
      <ModalHeader
        toggle={() => toggle()}
        iconClass="fa-object-group"
        description="Detalle de alergia"
        subtitle="Revise las moléculas del grupo alérgico seleccionado."
      />
      <ModalBody>
        <DetailList
          items={[
            {
              label: "Grupo Alérgico",
              value: selectedItem?.allergyGroup?.name,
            },
          ]}
        />

        <Row form className="mt-3">
          <Col xs={12}>
            <ReactTable
              data={data || []}
              loading={loadingMolecules}
              className="-striped -highlight"
              noDataText="No se encontraron moléculas"
              defaultPageSize={10}
              showPagination={false}
              columns={[
                {
                  Header: "Molécula",
                  accessor: "name",
                  sortable: true,
                },
              ]}
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          className="btn-color-danger"
          onClick={() => toggle()}
        >
          <i className="fa fa-times" /> Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
